(function () {
  var CART_REQUEST_TIMEOUT = 5000;
  var CART_RETRY_DELAY = 500;

  var roots = document.querySelectorAll('[data-bc-cart]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    initProgressBars(root);
    initQuantityMemory(root);
    initShippingBadges(root);
    runCartChecks(root, getDomCart(root));
    initCartControls(root);
    initCartAutoSync(root);
  });

  function initProgressBars(root) {
    if (window.BCCartUi && typeof window.BCCartUi.initProgressBars === 'function') {
      window.BCCartUi.initProgressBars(root);
    }
  }

  function initShippingBadges(root) {
    if (window.BCCartUi && typeof window.BCCartUi.initShippingBadges === 'function') {
      window.BCCartUi.initShippingBadges(root);
    }
  }

  function getStockQuantityAdjustmentInfos(sourceRoot, cart) {
    var cartQuantitiesByKey = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      cartQuantitiesByKey[item.key] = item.quantity;
    });

    var groups = {};
    Array.prototype.slice.call(sourceRoot.querySelectorAll('.bc-item[data-key][data-variant-id]')).forEach(function (item) {
      var key = item.getAttribute('data-key') || '';
      var variantId = item.getAttribute('data-variant-id') || '';
      var managed = item.getAttribute('data-bc-inventory-managed') === 'true';
      var policy = item.getAttribute('data-bc-inventory-policy') || '';
      var inventoryQuantity = parseInt(item.getAttribute('data-bc-inventory-quantity') || '0', 10);
      var input = item.querySelector('[data-bc-qty-input]');
      var domQuantity = input ? parseInt(input.value || '0', 10) : 0;
      var cartQuantity = typeof cartQuantitiesByKey[key] === 'number' ? cartQuantitiesByKey[key] : domQuantity;

      if (!key || !variantId || !managed || policy !== 'deny') return;
      if (isNaN(inventoryQuantity)) inventoryQuantity = 0;
      if (isNaN(cartQuantity)) cartQuantity = 0;

      if (!groups[variantId]) {
        groups[variantId] = {
          variantId: variantId,
          name: item.getAttribute('data-bc-out-of-stock-name') || 'un prodotto',
          inventoryQuantity: inventoryQuantity,
          lines: [],
          cartQuantity: 0
        };
      }

      groups[variantId].inventoryQuantity = Math.min(groups[variantId].inventoryQuantity, inventoryQuantity);
      groups[variantId].cartQuantity += cartQuantity;
      groups[variantId].lines.push({
        key: key,
        quantity: cartQuantity
      });
    });

    var adjustments = [];
    var products = [];
    var outOfStockProducts = [];

    Object.keys(groups).forEach(function (variantId) {
      var group = groups[variantId];
      var stockLeft = Math.max(0, group.inventoryQuantity);

      if (group.cartQuantity <= stockLeft) return;

      var productInfo = {
        name: group.name,
        cartQuantity: group.cartQuantity,
        stockLeft: stockLeft
      };

      if (stockLeft <= 0) {
        productInfo.keys = group.lines.map(function (line) { return line.key; });
        outOfStockProducts.push(productInfo);
        return;
      }

      products.push(productInfo);

      var remaining = stockLeft;
      group.lines.forEach(function (line) {
        var nextQuantity = Math.min(line.quantity, remaining);
        remaining -= nextQuantity;

        if (nextQuantity !== line.quantity) {
          adjustments.push({
            key: line.key,
            quantity: nextQuantity
          });
        }
      });
    });

    return {
      adjustments: adjustments,
      products: products,
      outOfStockProducts: outOfStockProducts
    };
  }

  function checkAndShowStockQuantityAdjustments(root, cart, sourceRoot) {
    var stockAdjustmentData = getStockQuantityAdjustmentInfos(sourceRoot || root, cart);

    if (stockAdjustmentData.outOfStockProducts.length) {
      showOutOfStockRemovalModal(root, stockAdjustmentData.outOfStockProducts);
      return true;
    }

    if (!stockAdjustmentData.adjustments.length) return false;

    showStockQuantityAdjustmentModal(root, stockAdjustmentData);
    return true;
  }

  function runCartChecks(root, cart, sourceRoot) {
    return checkAndShowStockQuantityAdjustments(root, cart, sourceRoot);
  }

  function showOutOfStockRemovalModal(root, products) {
    if (!products || !products.length || root.getAttribute('data-bc-stock-modal-open') === '1') return;

    var modal = root.querySelector('[data-bc-stock-modal]');
    var title = root.querySelector('.bc-stock-modal__title');
    var body = root.querySelector('[data-bc-stock-modal-body]');
    var removalText = root.querySelector('[data-bc-stock-modal-removal]');
    if (!modal) return;

    if (title) title.textContent = products.length === 1 ? 'Prodotto esaurito' : 'Prodotti esauriti';

    if (body) {
      if (products.length === 1) {
        body.textContent = 'Il prodotto "' + products[0].name + '" ha esaurito tutte le scorte.';
      } else {
        body.textContent = 'Alcuni prodotti nel carrello hanno esaurito tutte le scorte: ' + products.map(function (product) {
          return product.name;
        }).join('; ') + '.';
      }
    }

    if (removalText) {
      removalText.textContent = products.length === 1
        ? 'Verrà rimosso automaticamente dal carrello.'
        : 'Verranno rimossi automaticamente dal carrello.';
    }

    var closed = false;
    function onOutOfStockKeydown(e) {
      if (e.key !== 'Escape') return;
      closeAndRemove();
    }

    function closeAndRemove() {
      if (closed) return;
      closed = true;
      document.removeEventListener('keydown', onOutOfStockKeydown);
      root.setAttribute('data-bc-availability-refreshing', '1');
      modal.classList.remove('is-open');
      modal.hidden = true;

      var removals = [];
      products.forEach(function (product) {
        (product.keys || []).forEach(function (key) {
          if (key) removals.push({ key: key, quantity: 0 });
        });
      });
      applyCartQuantityAdjustments(root, removals, true);
    }

    root.setAttribute('data-bc-stock-modal-open', '1');
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.onclick = closeAndRemove;

    document.addEventListener('keydown', onOutOfStockKeydown);
  }

  function showStockQuantityAdjustmentModal(root, data) {
    if (!data || !data.adjustments.length || !data.products.length || root.getAttribute('data-bc-stock-modal-open') === '1') return;

    var modal = root.querySelector('[data-bc-stock-modal]');
    var title = root.querySelector('.bc-stock-modal__title');
    var body = root.querySelector('[data-bc-stock-modal-body]');
    var removalText = root.querySelector('[data-bc-stock-modal-removal]');
    if (!modal) return;

    if (title) title.textContent = 'Disponibilità aggiornata';

    if (body) {
      if (data.products.length === 1) {
        var product = data.products[0];
        body.textContent = 'Il prodotto "' + product.name + '" è stato venduto e a magazzino ne sono rimasti ' + product.stockLeft + '. Nel carrello ne avevi ' + product.cartQuantity + ': portiamo automaticamente la quantità da ' + product.cartQuantity + ' a ' + product.stockLeft + '.';
      } else {
        body.textContent = 'Alcuni prodotti nel carrello hanno disponibilità cambiata: ' + data.products.map(function (product) {
          return product.name + ' (nel carrello ' + product.cartQuantity + ', rimasti ' + product.stockLeft + ', portiamo a ' + product.stockLeft + ')';
        }).join('; ') + '.';
      }
    }

    if (removalText) removalText.textContent = 'Aggiorniamo automaticamente il carrello lasciando solo le quantità ancora disponibili.';

    var closed = false;
    function onStockAdjustmentKeydown(e) {
      if (e.key !== 'Escape') return;
      closeAndApply();
    }

    function closeAndApply() {
      if (closed) return;
      closed = true;
      document.removeEventListener('keydown', onStockAdjustmentKeydown);
      root.removeAttribute('data-bc-stock-modal-open');
      modal.classList.remove('is-open');
      modal.hidden = true;

      applyCartQuantityAdjustments(root, data.adjustments);
    }

    root.setAttribute('data-bc-stock-modal-open', '1');
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.onclick = closeAndApply;

    document.addEventListener('keydown', onStockAdjustmentKeydown);
  }

  function showStockLimitModal(root, info, requestedQuantity) {
    if (!info || root.getAttribute('data-bc-stock-modal-open') === '1') return;

    var modal = root.querySelector('[data-bc-stock-modal]');
    var title = root.querySelector('.bc-stock-modal__title');
    var body = root.querySelector('[data-bc-stock-modal-body]');
    var removalText = root.querySelector('[data-bc-stock-modal-removal]');
    if (!modal) return;

    if (title) title.textContent = 'Disponibilità insufficiente';
    if (body) {
      body.textContent = 'Non è possibile portare "' + info.name + '" a ' + requestedQuantity + ' articoli: a magazzino ne sono rimasti ' + info.stockLeft + '.';
    }
    if (removalText) {
      removalText.textContent = 'La quantità nel carrello resta a ' + info.limit + '.';
    }

    function onStockLimitKeydown(e) {
      if (e.key !== 'Escape') return;
      closeOnly();
    }

    function closeOnly() {
      document.removeEventListener('keydown', onStockLimitKeydown);
      root.removeAttribute('data-bc-stock-modal-open');
      modal.classList.remove('is-open');
      modal.hidden = true;
    }

    root.setAttribute('data-bc-stock-modal-open', '1');
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.onclick = closeOnly;

    document.addEventListener('keydown', onStockLimitKeydown);
  }

  function fetchWithCacheBust(url, options) {
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    var requestOptions = Object.assign({}, options || {});
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = null;

    if (controller) {
      requestOptions.signal = controller.signal;
      timeout = window.setTimeout(function () {
        controller.abort();
      }, CART_REQUEST_TIMEOUT);
    }

    return fetch(url + joiner + '_bc_ts=' + Date.now(), requestOptions).finally(function () {
      if (timeout) window.clearTimeout(timeout);
    });
  }

  function reloadPageWithCacheBust() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('_bc_cart_refresh', String(Date.now()));
      window.location.replace(url.toString());
    } catch (e) {
      window.location.reload();
    }
  }

  function fetchCartJson(root) {
    var cartUrl = root.getAttribute('data-bc-cart-url') || '/cart';
    return fetchWithCacheBust(cartUrl + '.js', {
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function fetchCartDocument(root) {
    var cartUrl = root.getAttribute('data-bc-cart-url') || '/cart';
    var sectionId = root.getAttribute('data-bc-section-id') || '';
    var documentUrl = sectionId ? (cartUrl + '?section_id=' + encodeURIComponent(sectionId)) : cartUrl;

    return fetchWithCacheBust(documentUrl, {
      headers: {
        'Accept': 'text/html',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart HTML request failed');
      return response.text();
    }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function fetchCartState(root) {
    return Promise.all([fetchCartJson(root), fetchCartDocument(root)]).then(function (results) {
      var remoteRoot = results[1].querySelector('[data-bc-cart]');
      if (!remoteRoot) throw new Error('Cart root missing');

      return {
        cart: results[0],
        remoteRoot: remoteRoot
      };
    });
  }

  function applyCartQuantityAdjustments(root, adjustments, reloadAfter) {
    var cartChangeUrl = root.getAttribute('data-bc-cart-change-url') || '/cart/change.js';
    var sequence = Promise.resolve();

    adjustments.forEach(function (adjustment) {
      sequence = sequence.then(function () {
        return fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: adjustment.key, quantity: adjustment.quantity })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart item update failed');
          return response.json();
        });
      });
    });

    function finishAdjustment() {
      if (reloadAfter) {
        reloadPageWithCacheBust();
        return;
      }
      return syncCartMarkupFromServer(root);
    }

    return sequence.then(finishAdjustment).catch(finishAdjustment);
  }

  function getLocalCartSignature(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.bc-item[data-key]')).map(function (item) {
      var input = item.querySelector('[data-bc-qty-input]');
      var qty = input ? parseInt(input.value || '0', 10) : 0;
      if (isNaN(qty)) qty = 0;
      return item.getAttribute('data-key') + ':' + qty;
    }).join('|');
  }

  function getCartSignature(cart) {
    return (cart && cart.items ? cart.items : []).map(function (item) {
      return item.key + ':' + item.quantity;
    }).join('|');
  }

  function syncLatestCartState(root) {
    return fetchCartState(root).then(function (state) {
      if (state.cart && state.cart.item_count > 0 && runCartChecks(root, state.cart, state.remoteRoot)) {
        return false;
      }

      if (getCartSignature(state.cart) !== getLocalCartSignature(root)) {
        replaceCartWrap(root, state.remoteRoot);
      } else if (hasAvailabilityChanges(root, state.remoteRoot)) {
        showCartAvailabilityChangedModal(root, state.remoteRoot);
        return false;
      } else {
        syncAvailabilityFromRemote(root, state.remoteRoot);
      }

      return true;
    }).catch(function () {
      return false;
    });
  }

  function getDomCart(root) {
    return {
      items: Array.prototype.slice.call(root.querySelectorAll('.bc-item[data-key]')).map(function (item) {
        var input = item.querySelector('[data-bc-qty-input]');
        var quantity = input ? parseInt(input.value || '0', 10) : 0;
        if (isNaN(quantity)) quantity = 0;

        return {
          key: item.getAttribute('data-key') || '',
          quantity: quantity
        };
      })
    };
  }

  function getStockLimitForItem(root, item) {
    if (!item) return null;

    var key = item.getAttribute('data-key') || '';
    var variantId = item.getAttribute('data-variant-id') || '';
    var managed = item.getAttribute('data-bc-inventory-managed') === 'true';
    var policy = item.getAttribute('data-bc-inventory-policy') || '';
    var stockLeft = parseInt(item.getAttribute('data-bc-inventory-quantity') || '0', 10);

    if (!key || !variantId || !managed || policy !== 'deny') return null;
    if (isNaN(stockLeft)) stockLeft = 0;
    stockLeft = Math.max(0, stockLeft);

    var otherQuantity = 0;
    Array.prototype.slice.call(root.querySelectorAll('.bc-item[data-variant-id="' + cssEscape(variantId) + '"]')).forEach(function (otherItem) {
      if (otherItem === item) return;
      var input = otherItem.querySelector('[data-bc-qty-input]');
      var quantity = input ? parseInt(input.value || '0', 10) : 0;
      if (!isNaN(quantity)) otherQuantity += quantity;
    });

    return {
      key: key,
      name: item.getAttribute('data-bc-out-of-stock-name') || 'un prodotto',
      stockLeft: stockLeft,
      limit: Math.max(0, stockLeft - otherQuantity)
    };
  }

  function getInputQuantity(input, fallback) {
    var quantity = parseInt(input && input.value ? input.value : fallback, 10);
    return isNaN(quantity) ? 0 : quantity;
  }

  function getItemByKey(root, key) {
    return key ? root.querySelector('.bc-item[data-key="' + cssEscape(key) + '"]') : null;
  }

  function rememberValidQuantity(input) {
    if (!input) return;
    input.setAttribute('data-bc-last-valid-qty', String(getInputQuantity(input, input.defaultValue || '0')));
  }

  function getLastValidQuantity(input) {
    if (!input) return 0;
    var value = input.getAttribute('data-bc-last-valid-qty');
    if (value === null || value === '') value = input.defaultValue || input.getAttribute('value') || input.value || '0';
    var quantity = parseInt(value, 10);
    return isNaN(quantity) ? 0 : quantity;
  }

  function validateCartQuantities(root) {
    return !runCartChecks(root, getDomCart(root));
  }

  function initQuantityMemory(root) {
    root.querySelectorAll('[data-bc-qty-input]').forEach(function (input) {
      var item = input.closest('.bc-item');
      var limitInfo = getStockLimitForItem(root, item);
      if (limitInfo) input.setAttribute('max', String(limitInfo.limit));
      else input.removeAttribute('max');

      rememberValidQuantity(input);
    });
  }

  function replaceCartWrap(root, remoteRoot) {
    var localWrap = root.querySelector('.bc-wrap');
    var remoteWrap = remoteRoot ? remoteRoot.querySelector('.bc-wrap') : null;
    if (!localWrap || !remoteWrap) return;

    localWrap.innerHTML = remoteWrap.innerHTML;
    initProgressBars(root);
    initQuantityMemory(root);
    initShippingBadges(root);
  }

  function syncAvailabilityFromRemote(root, remoteRoot) {
    var changed = false;

    Array.prototype.slice.call(root.querySelectorAll('.bc-item[data-key]')).forEach(function (localItem) {
      var key = localItem.getAttribute('data-key');
      var remoteItem = remoteRoot.querySelector('.bc-item[data-key="' + cssEscape(key) + '"]');
      if (!remoteItem) return;

      copyOptionalAttribute(remoteItem, localItem, 'data-bc-out-of-stock-name');
      copyOptionalAttribute(remoteItem, localItem, 'data-bc-inventory-managed');
      copyOptionalAttribute(remoteItem, localItem, 'data-bc-inventory-quantity');
      copyOptionalAttribute(remoteItem, localItem, 'data-bc-inventory-policy');

      var localExtra = localItem.querySelector('.bc-extra');
      var remoteExtra = remoteItem.querySelector('.bc-extra');
      if (localExtra && remoteExtra && getAvailabilitySignature(localExtra) !== getAvailabilitySignature(remoteExtra)) {
        localExtra.outerHTML = remoteExtra.outerHTML;
        changed = true;
      }
    });

    if (changed) {
      initShippingBadges(root);
    }
    initQuantityMemory(root);
  }

  function hasAvailabilityChanges(root, remoteRoot) {
    return Array.prototype.slice.call(root.querySelectorAll('.bc-item[data-key]')).some(function (localItem) {
      var key = localItem.getAttribute('data-key');
      var remoteItem = remoteRoot.querySelector('.bc-item[data-key="' + cssEscape(key) + '"]');
      if (!remoteItem) return false;

      return getItemAvailabilitySignature(localItem) !== getItemAvailabilitySignature(remoteItem);
    });
  }

  function getItemAvailabilitySignature(item) {
    var extra = item.querySelector('.bc-extra');

    /*
      Il popup generico deve apparire solo quando cambia lo stato del badge.
      Quantita, policy e altri dati tecnici vengono comunque sincronizzati e
      restano disponibili ai controlli dedicati che correggono le quantita o
      rimuovono un articolo esaurito.
    */
    return extra ? getAvailabilitySignature(extra) : '';
  }

  function showCartAvailabilityChangedModal(root, remoteRoot) {
    if (root.getAttribute('data-bc-stock-modal-open') === '1') return true;

    var modal = root.querySelector('[data-bc-stock-modal]');
    var title = root.querySelector('.bc-stock-modal__title');
    var body = root.querySelector('[data-bc-stock-modal-body]');
    var removalText = root.querySelector('[data-bc-stock-modal-removal]');
    if (!modal) return false;

    if (title) title.textContent = 'Disponibilità aggiornata';
    if (body) body.textContent = 'Ci sono stati cambiamenti nella disponibilità di alcuni prodotti presenti nel carrello.';
    if (removalText) removalText.textContent = 'Ricarichiamo la pagina con i valori corretti.';

    var closed = false;
    function closeAndRefresh() {
      if (closed) return;
      closed = true;
      document.removeEventListener('keydown', onAvailabilityModalKeydown);
      root.setAttribute('data-bc-availability-refreshing', '1');
      modal.classList.remove('is-open');
      modal.hidden = true;
      reloadPageWithCacheBust();
    }

    function onAvailabilityModalKeydown(e) {
      if (e.key !== 'Escape') return;
      closeAndRefresh();
    }

    root.setAttribute('data-bc-stock-modal-open', '1');
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.onclick = closeAndRefresh;

    document.addEventListener('keydown', onAvailabilityModalKeydown);

    return true;
  }

  function getAvailabilitySignature(extra) {
    var availability = extra.querySelector('.bc-availability');
    if (!availability) return 'availability:missing';

    /*
      Il testo del badge e il className completo sono contenuti di
      presentazione: proxy e traduttori automatici possono modificarli nel DOM
      senza che la disponibilita sia realmente cambiata. La firma Liquid usa
      solo stato applicativo e tipo di badge, che restano uguali in ogni lingua.
    */
    var semanticSignature = availability.getAttribute('data-bc-availability-signature');
    if (semanticSignature) return semanticSignature;

    /*
      Fallback per markup in cache o durante un deploy non atomico. Considera
      soltanto i modificatori applicativi, ignorando testo e classi di terze parti.
    */
    var stateClasses = [
      'bc-availability--is-available',
      'bc-availability--is-preorder',
      'bc-availability--is-out',
      'bc-availability--is-unknown'
    ].filter(function (className) {
      return availability.classList.contains(className);
    }).sort();
    var badgeType = availability.hasAttribute('data-bc-ship-badge') ? 'ship' : 'static';

    return stateClasses.join(',') + '|' + badgeType;
  }

  function copyOptionalAttribute(source, target, name) {
    if (source.hasAttribute(name)) {
      target.setAttribute(name, source.getAttribute(name) || '');
    } else {
      target.removeAttribute(name);
    }
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function syncCartMarkupFromServer(root) {
    return fetchCartState(root).then(function (state) {
      replaceCartWrap(root, state.remoteRoot);

      if (state.cart && state.cart.item_count > 0 && runCartChecks(root, state.cart)) {
        return;
      }
    }).catch(function () {});
  }

  function initCartAutoSync(root) {
    var polling = false;
    var retryTimer = null;

    function retrySoon() {
      window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(poll, CART_RETRY_DELAY);
    }

    function poll() {
      if (polling || root.getAttribute('data-bc-stock-modal-open') === '1' || root.getAttribute('data-bc-availability-refreshing') === '1' || isQuantitySyncing(root)) return;
      if (isQuantityEditing(root)) return;
      polling = true;

      fetchCartState(root).then(function (state) {
        if (runCartChecks(root, state.cart, state.remoteRoot)) {
          return;
        }

        if (getCartSignature(state.cart) !== getLocalCartSignature(root)) {
          replaceCartWrap(root, state.remoteRoot);
        } else if (hasAvailabilityChanges(root, state.remoteRoot)) {
          showCartAvailabilityChangedModal(root, state.remoteRoot);
        } else {
          syncAvailabilityFromRemote(root, state.remoteRoot);
        }
      }).catch(function () {
        retrySoon();
      }).finally(function () {
        polling = false;
      });
    }

    window.setInterval(poll, 2000);
    window.setTimeout(poll, 500);
    window.addEventListener('focus', poll);
    window.addEventListener('pageshow', poll);
    window.addEventListener('online', poll);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) poll();
    });
  }

  function isQuantityEditing(root) {
    var active = document.activeElement;
    return !!(active && root.contains(active) && active.matches('[data-bc-qty-input]'));
  }

  function isQuantitySyncing(root) {
    return root.getAttribute('data-bc-qty-syncing') === '1';
  }

  function beginQuantitySync(root) {
    if (isQuantitySyncing(root)) return false;
    root.setAttribute('data-bc-qty-syncing', '1');
    return true;
  }

  function endQuantitySync(root) {
    root.removeAttribute('data-bc-qty-syncing');
  }

  function initCartControls(root) {
    var cartUrl = root.getAttribute('data-bc-cart-url') || '/cart';
    var cartUpdateUrl = root.getAttribute('data-bc-cart-update-url') || '/cart/update.js';
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var cartClearUrl = root.getAttribute('data-bc-cart-clear-url') || (shopifyRoot + 'cart/clear');

    function clearCart() {
      return fetch(cartClearUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: ''
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart clear failed: HTTP ' + response.status);
        return response.json();
      });
    }

    function getCartForm() {
      return root.querySelector('[data-bc-cart-form]');
    }

    function getHiddenUpdateButton() {
      return root.querySelector('[data-bc-hidden-update]');
    }

    function getConfirmModal() {
      return root.querySelector('[data-bc-modal]');
    }

    function getConfirmModalTitle() {
      return root.querySelector('[data-bc-modal-title]');
    }

    function getConfirmModalBody() {
      return root.querySelector('[data-bc-modal-body]');
    }

    function getConfirmModalButton() {
      return root.querySelector('[data-bc-confirm]');
    }

    function submitUpdate() {
      var form = getCartForm();
      var updateBtn = getHiddenUpdateButton();
      if (!form || !updateBtn) return;
      root.setAttribute('data-bc-allow-update-submit', '1');
      updateBtn.click();
      window.setTimeout(function () {
        root.removeAttribute('data-bc-allow-update-submit');
      }, 0);
    }

    function openModal(options) {
      var modal = getConfirmModal();
      var modalTitle = getConfirmModalTitle();
      var modalBody = getConfirmModalBody();
      var modalConfirm = getConfirmModalButton();
      if (!modal || !modalConfirm) return false;

      if (modalTitle && options && options.title) modalTitle.textContent = options.title;
      if (modalBody && options && options.body) modalBody.textContent = options.body;
      if (options && options.confirmText) modalConfirm.textContent = options.confirmText;

      modalConfirm.removeAttribute('aria-disabled');
      modalConfirm.setAttribute('data-bc-modal-action', (options && options.action) ? options.action : 'remove-item');
      modalConfirm.setAttribute('href', (options && options.href) ? options.href : '#');
      modal.style.display = 'flex';
      return true;
    }

    function closeModal() {
      var modal = getConfirmModal();
      var modalTitle = getConfirmModalTitle();
      var modalBody = getConfirmModalBody();
      var modalConfirm = getConfirmModalButton();
      if (!modal || !modalConfirm) return;
      modal.style.display = 'none';
      if (modalTitle) modalTitle.textContent = "Rimuovere l'articolo?";
      if (modalBody) modalBody.textContent = 'Vuoi rimuovere questo articolo dal carrello?';
      modalConfirm.textContent = 'Rimuovi';
      modalConfirm.removeAttribute('aria-disabled');
      modalConfirm.setAttribute('data-bc-modal-action', 'remove-item');
      modalConfirm.setAttribute('href', '#');
    }

    function applyRequestedQuantity(input, requestedQuantity) {
      if (!input || !input.matches('[data-bc-qty-input]')) return false;

      var item = input.closest('.bc-item');

      if (requestedQuantity < 0) requestedQuantity = 0;
      var lastValidQuantity = getLastValidQuantity(input);

      var limitInfo = getStockLimitForItem(root, item);
      if (limitInfo && requestedQuantity > limitInfo.limit) {
        if (limitInfo.limit <= 0) {
          input.value = String(lastValidQuantity);
          var outOfStockProduct = {
            name: limitInfo.name,
            cartQuantity: requestedQuantity,
            stockLeft: 0,
            keys: [limitInfo.key]
          };
          showOutOfStockRemovalModal(root, [outOfStockProduct]);
          return false;
        }

        input.value = String(limitInfo.limit);

        if (lastValidQuantity !== limitInfo.limit) {
          showStockQuantityAdjustmentModal(root, {
            adjustments: [{ key: limitInfo.key, quantity: limitInfo.limit }],
            products: [{ name: limitInfo.name, cartQuantity: requestedQuantity, stockLeft: limitInfo.limit }]
          });
        } else {
          showStockLimitModal(root, limitInfo, requestedQuantity);
        }
        return false;
      }

      input.value = String(requestedQuantity);
      if (requestedQuantity === lastValidQuantity) return true;

      rememberValidQuantity(input);
      submitUpdate();
      return true;
    }

    function handleQuantityInput(input) {
      if (!input || !input.matches('[data-bc-qty-input]')) return Promise.resolve(false);
      var item = input.closest('.bc-item');
      if (!beginQuantitySync(root)) return Promise.resolve(false);

      var key = item ? item.getAttribute('data-key') : '';
      var requestedQuantity = getInputQuantity(input, '0');
      var fallbackQuantity = getLastValidQuantity(input);

      return syncLatestCartState(root).then(function (synced) {
        if (!synced) {
          if (input && root.contains(input)) input.value = String(fallbackQuantity);
          return false;
        }

        var freshItem = getItemByKey(root, key);
        var freshInput = freshItem ? freshItem.querySelector('[data-bc-qty-input]') : null;
        if (!freshInput) return false;

        return applyRequestedQuantity(freshInput, requestedQuantity);
      }).finally(function () {
        endQuantitySync(root);
      });
    }

    function handleQuantityButton(qtyBtn) {
      var item = qtyBtn ? qtyBtn.closest('.bc-item') : null;
      if (!item || !beginQuantitySync(root)) return;

      var key = item.getAttribute('data-key') || '';
      var direction = qtyBtn.getAttribute('data-bc-qty');
      qtyBtn.disabled = true;

      syncLatestCartState(root).then(function (synced) {
        if (!synced) return false;

        var freshItem = getItemByKey(root, key);
        var freshInput = freshItem ? freshItem.querySelector('[data-bc-qty-input]') : null;
        if (!freshInput) return false;

        var currentQuantity = getInputQuantity(freshInput, '0');
        var nextQuantity = direction === 'inc' ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);
        return applyRequestedQuantity(freshInput, nextQuantity);
      }).finally(function () {
        if (qtyBtn && root.contains(qtyBtn)) qtyBtn.disabled = false;
        endQuantitySync(root);
      });
    }

    function skipNextQuantityChange(input) {
      if (!input) return;

      input.setAttribute('data-bc-skip-next-change', '1');
      window.clearTimeout(input._bcSkipNextChangeTimer);
      input._bcSkipNextChangeTimer = window.setTimeout(function () {
        input.removeAttribute('data-bc-skip-next-change');
      }, 500);
    }

    function shouldSkipQuantityBlurCommit(target) {
      if (!target) return false;
      var closest = target.closest ? target.closest.bind(target) : null;
      if (!closest && target.parentElement && target.parentElement.closest) {
        closest = target.parentElement.closest.bind(target.parentElement);
      }
      if (!closest) return false;

      return !!closest(
        '[data-bc-remove], [data-bc-clear-cart], [data-bc-discount-remove], [data-bc-apply-discount], [data-bc-confirm], [data-bc-cancel], button, a, input, textarea, select'
      );
    }

    function markQuantityBlurSkip(e) {
      if (!document.activeElement || !document.activeElement.matches('[data-bc-qty-input]')) return;
      if (!shouldSkipQuantityBlurCommit(e.target)) return;

      root.setAttribute('data-bc-skip-qty-blur-commit', '1');
      window.clearTimeout(root._bcSkipQtyBlurTimer);
      root._bcSkipQtyBlurTimer = window.setTimeout(function () {
        root.removeAttribute('data-bc-skip-qty-blur-commit');
      }, 300);
    }

    function submitFormAfterLiveCheck(submitter) {
      root.setAttribute('data-bc-allow-cart-submit', '1');

      var form = getCartForm();
      var submitterName = submitter ? submitter.getAttribute('name') : '';
      var freshSubmitter = submitterName ? root.querySelector('[type="submit"][name="' + cssEscape(submitterName) + '"]') : null;

      if (freshSubmitter) {
        freshSubmitter.click();
      } else if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else if (form) {
        form.submit();
      }
    }

    (function checkDiscountResult() {
      try {
        var u = new URL(window.location.href);
        if (!u.searchParams.get('bc_discount_check')) return;

        var hasEl = root.querySelector('[data-bc-any-discount]');
        var hasAny = hasEl ? hasEl.getAttribute('data-bc-any-discount') : '0';

        if (hasAny !== '1') {
          var errEl = root.querySelector('[data-bc-discount-error]');
          if (errEl) {
            var tried = '';
            try { tried = sessionStorage.getItem('bc_discount_try') || ''; } catch (e) {}
            errEl.textContent = tried ? ('Codice "' + tried + '" non trovato, non valido o requisiti di attivazione non soddisfatti.') : 'Codice sconto non trovato, non valido o requisiti di attivazione non soddisfatti.';
            errEl.hidden = false;
          }
        }

        u.searchParams.delete('bc_discount_check');
        window.history.replaceState({}, document.title, u.pathname + (u.search || '') + u.hash);
        try { sessionStorage.removeItem('bc_discount_try'); } catch (e) {}
      } catch (e) {}
    })();

    root.addEventListener('click', function (e) {
      var discBtn = e.target.closest('[data-bc-apply-discount]');
      if (discBtn) {
        e.preventDefault();

        var input = root.querySelector('[data-bc-discount-input]');
        var code = input ? String(input.value || '').trim() : '';
        if (!code) return;

        var errEl = root.querySelector('[data-bc-discount-error]');
        if (errEl) errEl.hidden = true;

        discBtn.disabled = true;

        fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code })
        })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (res.ok) {
            try { sessionStorage.setItem('bc_discount_try', code); } catch (e) {}
            var u = new URL(window.location.href);
            u.searchParams.set('bc_discount_check', '1');
            window.location.href = u.pathname + u.search + u.hash;
            return;
          }

          discBtn.disabled = false;
          if (errEl) {
            var msg = (res.data && (res.data.description || res.data.message)) ? String(res.data.description || res.data.message) : '';
            errEl.textContent = msg ? msg : 'Codice sconto non trovato o non valido.';
            errEl.hidden = false;
          }
        })
        .catch(function () {
          discBtn.disabled = false;
          if (errEl) {
            errEl.textContent = 'Impossibile applicare il codice sconto. Riprova.';
            errEl.hidden = false;
          }
        });
        return;
      }

      var removeDiscountBtn = e.target.closest('[data-bc-discount-remove]');
      if (removeDiscountBtn) {
        e.preventDefault();
        removeDiscountBtn.disabled = true;

        fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        })
        .then(function () { window.location.href = cartUrl; })
        .catch(function () { removeDiscountBtn.disabled = false; });
        return;
      }

      var clearCartBtn = e.target.closest('[data-bc-clear-cart]');
      if (clearCartBtn) {
        e.preventDefault();
        if (!openModal({
          title: 'Svuotare il carrello?',
          body: 'Vuoi davvero svuotare tutto il carrello?',
          confirmText: 'Svuota carrello',
          action: 'clear-cart'
        })) {
          clearCartBtn.disabled = true;

          clearCart()
          .then(function () { window.location.href = cartUrl; })
          .catch(function () { clearCartBtn.disabled = false; });
        }
        return;
      }

      var qtyBtn = e.target.closest('[data-bc-qty]');
      if (qtyBtn) {
        handleQuantityButton(qtyBtn);
        return;
      }

      var removeBtn = e.target.closest('[data-bc-remove]');
      if (removeBtn) {
        e.preventDefault();
        var url = removeBtn.getAttribute('data-bc-remove-url');

        if (url && openModal({
          title: "Rimuovere l'articolo?",
          body: 'Vuoi rimuovere questo articolo dal carrello?',
          confirmText: 'Rimuovi',
          action: 'remove-item',
          href: url
        })) {
        } else if (url) {
          window.location.href = url;
        }
        return;
      }

      var confirmBtn = e.target.closest('[data-bc-confirm]');
      if (confirmBtn && confirmBtn.getAttribute('data-bc-modal-action') === 'clear-cart') {
        e.preventDefault();
        if (confirmBtn.getAttribute('aria-disabled') === 'true') return;
        confirmBtn.setAttribute('aria-disabled', 'true');

        clearCart()
        .then(function () { window.location.href = cartUrl; })
        .catch(function () {
          confirmBtn.removeAttribute('aria-disabled');
          closeModal();
        });
        return;
      }

      if (e.target.closest('[data-bc-cancel]')) {
        closeModal();
        return;
      }

      var modal = getConfirmModal();
      if (modal && e.target === modal) {
        closeModal();
        return;
      }
    });

    root.addEventListener('pointerdown', markQuantityBlurSkip, true);
    root.addEventListener('mousedown', markQuantityBlurSkip, true);
    root.addEventListener('touchstart', markQuantityBlurSkip, true);

    root.addEventListener('submit', function (e) {
      if (!e.target || !e.target.matches('[data-bc-cart-form]')) return;

      if (root.getAttribute('data-bc-allow-cart-submit') === '1') {
        root.removeAttribute('data-bc-allow-cart-submit');
        return;
      }

      if (root.getAttribute('data-bc-allow-update-submit') === '1') {
        root.removeAttribute('data-bc-allow-update-submit');
        return;
      }

      if (document.activeElement && document.activeElement.matches('[data-bc-qty-input]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleQuantityInput(document.activeElement);
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      if (!beginQuantitySync(root)) return;

      var submitter = e.submitter || null;
      syncLatestCartState(root).then(function (synced) {
        if (synced && validateCartQuantities(root)) {
          submitFormAfterLiveCheck(submitter);
        }
      }).finally(function () {
        endQuantitySync(root);
      });
    }, true);

    root.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches('[data-bc-qty-input]')) {
        rememberValidQuantity(e.target);
      }
    });

    root.addEventListener('focusout', function (e) {
      if (!e.target || !e.target.matches('[data-bc-qty-input]')) return;

      var qtyWrapper = e.target.closest('.bc-qty');
      if (qtyWrapper && e.relatedTarget && qtyWrapper.contains(e.relatedTarget)) return;
      if (root.getAttribute('data-bc-skip-qty-blur-commit') === '1') {
        root.removeAttribute('data-bc-skip-qty-blur-commit');
        return;
      }

      skipNextQuantityChange(e.target);
      handleQuantityInput(e.target);
    });

    root.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('[data-bc-qty-input]')) return;

      if (e.target.getAttribute('data-bc-skip-next-change') === '1') {
        e.target.removeAttribute('data-bc-skip-next-change');
        return;
      }

      handleQuantityInput(e.target);
    });

    root.addEventListener('keydown', function (e) {
      if (e.target && e.target.matches('[data-bc-qty-input]') && e.key === 'Enter') {
        e.preventDefault();
        e.stopImmediatePropagation();
        skipNextQuantityChange(e.target);
        handleQuantityInput(e.target);
        return;
      }

      if (e.target && e.target.matches('[data-bc-discount-input]') && e.key === 'Enter') {
        e.preventDefault();
        var btn = root.querySelector('[data-bc-apply-discount]');
        if (btn) btn.click();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });
  }
})();
